import React, { Component } from 'react';
import styles from './styles.module.css';

import TEXT from '../../../../../data/text.json';

import PillButton from '../../../pill-button';
import Tooltip from '../../../Tooltip';
import Square from '../../../square';
import CrossIcon from '../../../../icons/Cross';
import TickOutlineIcon from '../../../../icons/TickOutline';
import TickIcon from '../../../../icons/Tick';

const ImageTile = ({
  image,
  isMain,
  mainDisabled,
  setMainClick,
  removeClick,
}) => {
  const mainButton = (
    <button
      type="button"
      disabled={mainDisabled}
      className={isMain ? styles.mainSelected : null}
      onClick={setMainClick}
    >
      {isMain ? (
        <TickIcon size={14} color="#3e5c76" />
      ) : (
        <TickOutlineIcon size={14} color="#fff" />
      )}
      <span>Main</span>
    </button>
  );

  return (
    <div className={styles.imagePreview}>
      <Square>
        {image.data ? (
          <div className={styles.imageContainer}>
            <img src={image.data} />
          </div>
        ) : (
          <p>Loading image</p>
        )}
      </Square>
      <div className={styles.nameAndButton}>
        <p title={image.name}>{image.name}</p>
        <div className={styles.actions}>
          {mainDisabled ? (
            <Tooltip inline text="Item must have one main image">
              {mainButton}
            </Tooltip>
          ) : (
            mainButton
          )}
          <button onClick={removeClick}>
            <CrossIcon size={14} color="#fff" />
            <span>Remove</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default class ImageSelection extends Component {
  fileSelected = event => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const newArray = [
        ...this.props.images,
        {
          name: file.name,
          loading: false,
          data: reader.result,
          blob: file,
        },
      ];
      this.props.onChange(newArray);
    };

    reader.readAsDataURL(file);
  };

  removeImage = index => {
    const newArray = [...this.props.images];
    newArray.splice(index, 1);
    this.props.onChange(newArray, index === this.props.mainImageValue, index);
  };

  render() {
    return (
      <div className={styles.container}>
        <input
          type="file"
          id={TEXT.FORMS.imagesId}
          onChange={this.fileSelected}
          accept="image/x-png,image/gif,image/jpeg"
          value=""
        />
        <PillButton
          tag="label"
          theme="blue"
          htmlFor={TEXT.FORMS.imagesId}
          text={TEXT.FORMS.imagesLabel}
        />

        <p className={styles.amountSelectedLabel}>
          {this.props.images.length === 0
            ? TEXT.FORMS.imageNoneSelected
            : TEXT.FORMS.imagesXSelected
                .replace('{x}', this.props.images.length)
                .replace('(s)', this.props.images.length > 1 ? 's' : '')}
        </p>

        {this.props.images.length > 0 && (
          <div className={styles.previews}>
            {this.props.images.map((image, index) => (
              <ImageTile
                key={`${image.name}-${index}`}
                image={image}
                isMain={this.props.mainImageValue === index}
                mainDisabled={
                  this.props.requiresMain && this.props.mainImageValue === index
                }
                setMainClick={event =>
                  this.props.setMainImageValue({
                    target: {
                      value: this.props.mainImageValue === index ? null : index,
                    },
                  })}
                removeClick={() => this.removeImage(index)}
              />
            ))}
            <p>
              Select an image as the "main" image for an item and it will be the
              image shown in search results and the first image shown of the
              items page.
            </p>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/image-selection/index.js